<style lang="scss" scoped>
.package-info-box {
  display: flex;
  box-sizing: border-box;

  width: 6.68rem;
  margin-top: 0.14rem;
  padding: 0.4rem 0.52rem 0.22rem;

  background-color: #faf2e0;
  border-radius: 0.2rem;

  flex-direction: column;
  align-items: center;
}
.step-progress {
  position: relative;

  width: 100%;
  height: 0.24rem;
  margin-top: 0.34rem;
  overflow: hidden;

  background-color: #f0dfb8;
  border-radius: 0.12rem;

  text-align: right;
  box-shadow: 0px 2px 5px 0px rgba(191, 153, 115, 0.53) inset;
  &.step-progress2 {
    width: 100%;
  }
  .step-progress-rate {
    position: absolute;
    top: 0;
    left: 0;

    width: 30%;
    height: 100%;

    background: linear-gradient(
      180deg,
      rgba(255, 241, 212, 1) -10%,
      rgba(245, 227, 195, 1) 0%,
      rgba(201, 162, 95, 1)
    );
    border-radius: 0.12rem;
  }
  .step-progress-text {
    position: relative;
    top: -3px;
    right: 0.5rem;
    z-index: 1;

    font-size: 0.2rem;
    line-height: 0.24rem;
    color: #a36733;
  }
}
.package-coupon-box {
  display: flex;

  width: 100%;
  margin-top: 0.3rem;

  flex-wrap: wrap;
  justify-content: space-between;
  .package-coupon {
    box-sizing: border-box;

    width: 2.62rem;
    height: 1.86rem;
    margin-bottom: 0.14rem;
    padding: 0 0.2rem;

    background: no-repeat url('../images/bg_stage_operation_coupon.png');
    background-size: 100% 100%;
    .coupon-price-wrapper {
      margin-top: 0.22rem;
    }
    .coupon-price-box {
      display: flex;

      height: 0.56rem;

      justify-content: center;
      align-items: baseline;

      font-size: 0.36rem;
      line-height: 0.56rem;
      font-weight: 900;
      color: #fb3406;
      .coupon-price {
        margin-left: -0.04rem /* -2/50 */;

        font-size: 0.72rem;
        color: #fb3406;
        font-style: normal;
      }
    }
    .coupon-tip {
      height: 0.24rem;
      margin-top: 0.14rem;

      font-size: 0.24rem;
      line-height: 0.24rem;
      text-align: center;
      color: #a27d49;
    }
    .package-img {
      display: flex;

      width: 100%;
      height: 1.26rem;
      margin-top: 0.12rem;

      justify-content: center;
      img {
        width: 1.64rem;
        height: 100%;
      }
    }
    .coupon-title {
      width: 100%;
      margin-top: 0.14rem;
      overflow: hidden;

      border-top: 1px dashed #edc796;

      font-size: 0.24rem;
      line-height: 0.48rem;
      text-align: center;
      white-space: nowrap;
      color: #a27d49;
      text-overflow: ellipsis;
      &.gift-img-title {
        margin-top: 0;

        border: none;
      }
    }
  }
}
</style>

<template>
  <div class="package-info-box">
    <step-title title="丰厚礼包"></step-title>
    <div class="step-progress step-progress2">
      <span class="step-progress-text">{{ progressText }}</span>
      <div
        class="step-progress-rate"
        :style="{ width: completeSchedule + '%' }"
      ></div>
    </div>
    <div class="package-coupon-box">
      <div
        v-for="(item, index) in rewardInfo.rewardDtoList"
        :key="index"
        class="package-coupon"
      >
        <div v-if="item.phaseoperationtype === 2" class="package-img">
          <img
            :src="ossImage({ src: item.img_url, width: 82, height: 63 })"
            @error="imgLoadFail"
          />
        </div>
        <div v-else class="coupon-price-wrapper">
          <div class="coupon-price-box">
            ￥<i class="coupon-price">{{ item.faceValue }}</i>
          </div>
          <p class="coupon-tip">
            {{ item.threshold_msg }}
          </p>
        </div>
        <div
          class="coupon-title"
          :class="{ 'gift-img-title': item.phaseoperationtype === 2 }"
        >
          {{
            item.phaseoperationtype === 1
              ? item.couponDisplayName
              : item.sku_name
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepTitle from './StepTitle'
import { ossImage } from '@/utils/oss_image'
import { imgLoadFail } from '@/utils/utils'

export default {
  components: {
    StepTitle
  },
  props: {
    rewardInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    // 剩余礼包占比
    completeSchedule() {
      const schedule =
        Number(this.rewardInfo.remainAmount) / Number(this.rewardInfo.amount)
      return schedule > 1 ? 100 : parseInt(schedule * 100)
    },
    progressText() {
      return this.rewardInfo.remainAmount
        ? `礼包仅剩${this.rewardInfo.remainAmount}件，先到先得`
        : `礼包已经被抢光啦`
    }
  },
  methods: {
    ossImage,
    imgLoadFail
  }
}
</script>
